/**
 * SECURITY GUARD SYSTEM v1.0
 * Protege al usuario de descargas maliciosas, XSS y redirecciones forzadas.
 */

class SecurityGuard {
    constructor() {
        this.init();
    }

    init() {
        console.log('🛡️ SECURITY GUARD ACTIVADO');
        this.blockMaliciousDownloads();
        this.preventTabHijacking();
        this.disableContextTriggers();
    }

    // 1. Bloquear descargas de archivos ejecutables/peligrosos
    blockMaliciousDownloads() {
        document.addEventListener('click', (e) => {
            const link = e.target.closest('a');
            if (!link) return;

            const href = link.href.toLowerCase();
            const dangerousExtensions = ['.exe', '.dmg', '.bat', '.sh', '.vbs', '.msi', '.apk', '.iso'];

            if (dangerousExtensions.some(ext => href.endsWith(ext))) {
                e.preventDefault();
                e.stopPropagation();
                alert('⚠️ ARCHIVO BLOQUEADO POR SEGURIDAD\n\nCinemax ha detenido la descarga de un archivo potencialmente peligroso.');
                console.warn('⛔ Descarga maliciosa bloqueada:', href);
                return false;
            }
        }, true);
    }

    // 2. Prevenir que sitios externos secuestren la pestaña (Tab Hijacking)
    preventTabHijacking() {
        // Bloquear window.open no solicitado (si escapa del sandbox)
        const originalOpen = window.open;
        window.open = function (url, target, features) {
            // Permitir solo dominios de confianza si es necesario, o bloquear todo lo automático
            if (!url) return null;

            // Lista negra básica
            const blacklist = ['ad', 'click', 'track', 'bet', 'casino', 'virus', 'cleaner'];
            if (blacklist.some(term => url.includes(term))) {
                console.warn('⛔ Popup bloqueado:', url);
                return null;
            }
            return originalOpen(url, target, features);
        };

        // Bloquear navegación automática (redirecciones forzadas)
        window.addEventListener('beforeunload', (e) => {
            // Si el usuario no inició la acción, podríamos advertir
            // (Difícil de detectar 100%, pero podemos congelar timers)
        });
    }

    // 3. Desactivar menú contextual para evitar inspección simple (Opcional, seguridad por oscuridad)
    disableContextTriggers() {
        // Desactivar click derecho en imágenes e iframes
        document.addEventListener('contextmenu', (e) => {
            if (e.target.tagName === 'IMG' || e.target.tagName === 'IFRAME' || e.target.tagName === 'VIDEO') {
                e.preventDefault();
            }
        });
    }
}

export default SecurityGuard;
